import React from 'react';
import { Box, Typography, styled } from '@mui/material';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { Dayjs } from 'dayjs';
import CalendarTodayIcon from '@mui/icons-material/CalendarToday';
import { helperTextStyles, inputBaseStyles, requiredAsteriskStyles } from '../../styles/inputStyles';
import { formatDateForApi } from '../../utils/date';

interface DatePickerFieldProps {
  label?: string;
  value: Dayjs | null;
  onChange: (date: string | null) => void;
  maxDate?: Dayjs;
  width?: string;
  optional?: boolean;
  required?: boolean;
  helperText?: string;
  placeholder?: string;
  className?: string;
  disabled?: boolean;
}

const StyledDatePicker = styled(DatePicker)(() => ({
  ...inputBaseStyles,
  ...requiredAsteriskStyles
}));

const HelperText = styled(Typography)(() => ({
  ...helperTextStyles
}));

const DatePickerField: React.FC<DatePickerFieldProps> = ({
  label,
  value,
  onChange,
  maxDate,
  width = '100%',
  required = false,
  helperText,
  placeholder,
  className,
  disabled = false,
}) => {
  return (
    <Box sx={{ width }} className={className}>
      {label && (
        <Box sx={{ display: 'flex', alignItems: 'center', mb: 0.5 }}>
          <Typography component="label" className="input-field-label">
            {label}
            {required && <span>*</span>}
          </Typography>
        </Box>
      )}
      <LocalizationProvider dateAdapter={AdapterDayjs}>
        <StyledDatePicker
          value={value}
          onChange={(date) => onChange(formatDateForApi(date))}
          disabled={disabled}
          maxDate={maxDate}
          slots={{
            openPickerIcon: CalendarTodayIcon,
          }}
          slotProps={{
            textField: {
              placeholder: placeholder || '',
              fullWidth: true,
              error: !!helperText,
            },
          }}
        />
      </LocalizationProvider>
      {helperText && <HelperText>{helperText}</HelperText>}
    </Box>
  );
};

export default DatePickerField; 